import { useEffect, useState } from "react";
import api from "./api";

/* Live Tuber Audit counts, keyed by lowercase variety name.
   Returns a lookup fn: name -> counted qty (or null if not on the audit). */
export function useTuberAudit() {
  const [audit, setAudit] = useState({});
  useEffect(() => {
    api.get("/admin/tuber-audit").then((r) => {
      const map = {};
      for (const row of r.data?.rows || []) map[(row.name || "").trim().toLowerCase()] = Number(row.qty || 0);
      setAudit(map);
    }).catch(() => {});
  }, []);
  return (name) => {
    const q = audit[(name || "").trim().toLowerCase()];
    return q === undefined ? null : q;
  };
}
